module.exports = __webpack_public_path__ + "img/candy2.f8a83645.png";